import React from "react";
import { Input } from "@revvsales/components";
import { RevvForm /* ErrorMessages */ } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

import { DOCUMENTS } from "../../../../constants";

const { FORM_FIELDS_DEFAULT_VALUES } = DOCUMENTS;

export default class PersonNameFormMode extends React.Component {
  state = {
    // eslint-disable-next-line no-nested-ternary
    personNameTextFieldValues: this.props.initialProps.value
      ? JSON.parse(JSON.stringify(this.props.initialProps.value))
      : this.props.initialProps.meta && this.props.initialProps.meta.default
      ? JSON.parse(JSON.stringify(this.props.initialProps.meta.default))
      : FORM_FIELDS_DEFAULT_VALUES.PERSONNAME,
  };

  _handleOnBlurOnFirstName = (event, value, handleBlur, isValidated) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    if ((isValidated && value.firstName) || value.firstName === "") {
      const { id } = this.props.initialProps;
      const { firstName, lastName } = value;
      // const combinedValue = `${firstName} ${lastName}`;
      this.props._updateDynamicFieldsInDoc(id, value);
      this._checkForFirstNameUpdateField(value, firstName, lastName);
    }
  };

  _handleOnBlurOnLastName = (event, value, handleBlur, isValidated) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    if ((isValidated && value.lastName) || value.lastName === "") {
      const { id } = this.props.initialProps;
      const { firstName, lastName } = value;
      // const combinedValue = `${firstName} ${lastName}`;
      this.props._updateDynamicFieldsInDoc(id, value);
      this._checkForLastNameUpdateField(value, firstName, lastName);
    }
  };

  _checkForFirstNameUpdateField = (currentValue, checkFName, checkLName) => {
    const { id } = this.props.initialProps;
    const { firstName } = this.props.initialProps.value || {};
    if (firstName !== currentValue.firstName) {
      this.props._updateField(id, currentValue.firstName, "firstName");
      this._checkChangeStatus(checkFName, checkLName);
    }
  };

  _checkForLastNameUpdateField = (currentValue, checkFName, checkLName) => {
    const { id } = this.props.initialProps;
    const { lastName } = this.props.initialProps.value || {};
    if (lastName !== currentValue.lastName) {
      this.props._updateField(id, currentValue.lastName, "lastName");
      this._checkChangeStatus(checkFName, checkLName);
    }
  };

  _checkChangeStatus = (checkFName, checkLName) => {
    if (checkFName || checkLName) {
      this.props.filledStatus(true);
    } else this.props.filledStatus(false);
  };

  render() {
    const { id /* docIsLocked */ } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.personNameTextFieldValues}
          customFieldName="PERSON_NAME"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChange, handleBlur, messages, values } = formProps;
            return (
              <React.Fragment>
                <div>
                  <div className="composite-field-address">
                    <div className="composite-field-address-full-span">
                      <Input
                        id={id}
                        name="firstName"
                        className="form-mode-input"
                        // {`form-mode-input ${
                        //   messages.firstName &&
                        //   messages.firstName.required !== ""
                        //     ? "danger-border"
                        //     : ""
                        // }`}
                        placeholder="Enter first name"
                        value={
                          values && values.firstName ? values.firstName : ""
                        }
                        onChange={event => handleChange(event)}
                        onBlur={event =>
                          this._handleOnBlurOnFirstName(
                            event,
                            values,
                            handleBlur,
                            !messages.firstName,
                          )
                        }
                        disabled={this.props.isLocked}
                        autoFocus
                        data-test="person-firstname-field-form-mode"
                      />
                      {/* <div>
                        {messages.firstName && (
                          <ErrorMessages
                            messages={messages.firstName.required}
                          />
                        )}
                      </div> */}
                    </div>

                    <div className="composite-field-address-full-span">
                      <Input
                        id={id}
                        name="lastName"
                        className="form-mode-input"
                        // className={`form-mode-input ${
                        //   messages.lastName && messages.lastName.required !== ""
                        //     ? "danger-border"
                        //     : ""
                        // }`}
                        placeholder="Enter last name"
                        value={values && values.lastName ? values.lastName : ""}
                        onChange={event => handleChange(event)}
                        onBlur={event =>
                          this._handleOnBlurOnLastName(
                            event,
                            values,
                            handleBlur,
                            !messages.lastName,
                          )
                        }
                        disabled={this.props.isLocked}
                        data-test="person-lastname-field-form-mode"
                      />
                      <div>
                        {/* {messages.lastName && (
                          <ErrorMessages
                            messages={messages.lastName.required}
                          />
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/PersonNameFormMode.js